import shortid from 'shortid'

import iterateWorker from 'workerize-loader!./worker' // eslint-disable-line import/no-webpack-loader-syntax

const basicOts = {
  linLogMode: false,
  outboundAttractionDistribution: false,
  adjustSizes: false,
  barnesHutOptimize: true,
  strongGravityMode: true,

  edgeWeightInfluence: -10,
  barnesHutTheta: 1.0,
  gravity: 0.7,
  scalingRatio: 2
}

export default class Fa2 {
  constructor () {
    this.computing = true
    this.worker = iterateWorker()
    this.worker.addEventListener('error', (message) => console.log(message))
    this.iterationId = shortid()
    this.callbackFn = () => {}
  }

  run = (
    opts,
    iterationId,
    nodesLength,
    edgesLength,
    positions,
    fa2Arrrays,

    callback
  ) => {
    const defaultedOpts = Object.assign(
      basicOts, opts, {
        slowDown: 1 + Math.log(nodesLength)
      }
    )

    this.worker.removeEventListener('message', this.callbackFn)

    this.callbackFn = (message) => {
      if (message.data.result) {
        callback(message.data.result)
      }
    }
    this.worker.addEventListener('message', this.callbackFn)

    this.worker.run(
      defaultedOpts,

      nodesLength,
      edgesLength,
      iterationId,

      positions,
      fa2Arrrays.masses,
      fa2Arrrays.convergences,
      fa2Arrrays.sizes,
      fa2Arrrays.fixes,

      fa2Arrrays.edgesIndexes,
      fa2Arrrays.edgesValues
    )
  }
}
